angular.module('TetherApp').controller('PagesController', [
    '$anchorScroll',
    '$location',
    '$window',
    '$timeout',
    'Upload',
    'pagesService',
    'modelLockService',
    '$interval',
    function (
        $anchorScroll,
        $location,
        $window,
        $timeout,
        Upload,
        pagesService,
        modelLockService,
        $interval,
    ) {

        let self = this;
        let redirectTo = '/experience/pages';

        self.isSubmitting = false;

        self.pagesList = {};
        self.pages = {};
        self.currentPage = 1;
        self.isActivityDataOpen = {};

        //Model Lock
        self.modelLock;
        self.experienceLockTimeRemainingDisplay;
        self.experienceLockTimeEndDisplay;
        self.experienceLockCountdown = undefined;

        self.index = function (page) {
            self.currentPage = page;
            pagesService.indexPages(self.currentPage)
                .then(onIndex, onError);
        };

        let onIndex = function (data) {
            self.pagesList = data.data;
        };

        //START: SHOW SERVICE FUNCTIONS
        self.show = function (data) {
            self.pages = JSON.parse(JSON.stringify(data));
            self.getExperienceLock();
        };
        //END: SHOW SERVICE FUNCTIONS

        //START: STORE SERVICE FUNCTIONS
        self.store = function () {
            let tempPages = self.pages;

            self.isSubmitting = true;
            pagesService.storePages(tempPages)
                .then(onStore, onError);
        };

        let onStore = function (data) {
            redirectToIndex();
        };
        //END: STORE SERVICE FUNCTIONS

        //START: UPDATE SERVICE FUNCTIONS
        self.update = function () {
            let tempPages = self.pages;

            self.isSubmitting = true;
            pagesService.updatePages(tempPages)
                .then(onUpdate, onError);
        };

        let onUpdate = function (data) {
            self.releaseExperienceLock();
            redirectToIndex();
        };
        //END: UPDATE SERVICE FUNCTIONS

        //START: DESTROY SERVICE FUNCTIONS
        self.delete = function (pagesId) {
            if ($window.confirm(self.deleteText.replace(':id', pagesId))) {
                pagesService.deletePages(pagesId)
                    .then(onDelete, onError);
            }
        };

        let onDelete = function (data) {
            redirectToIndex();
        };
        //END: DESTROY SERVICE FUNCTIONS

        //START: GENERAL SERVICE FUNCTIONS
        let onError = function (data) {
            self.isSubmitting = false;
            $location.hash('top');
            $anchorScroll();
            self.errors = data.data.errors;
        };

        let redirectToIndex = function () {
            $window.location.href = '/' + self.client_eid + redirectTo;
        };
        //END: GENERAL SERVICE FUNCTIONS

        self.perPageChanged = function () {
            let form = window.document.querySelector('form#query_form');
            if (form) {
                $timeout(function () {
                    form.submit();
                });
            }
        };

        self.toggleActivityData = function (key) {
            if (self.isActivityDataOpen.hasOwnProperty(key)) {
                self.isActivityDataOpen[key] = !self.isActivityDataOpen[key];
            } else {
                self.isActivityDataOpen[key] = true;
            }
        };

        //START: EXPERIENCE EDIT TIMER

        self.getExperienceLock = function() {
            let lockData = {
                'type': 'editing',
                'model_id': self.pages.experience.eid,
                'model_type': 'experience',
            };
            modelLockService.lock(lockData).then(initiateExperienceLock, onError);
        }

        self.extendExperienceLock = function() {
            let lockData = {
                'type': 'editing',
                'model_id': self.pages.experience.eid,
                'model_type': 'experience',
            };
            modelLockService.extend(lockData).then(initiateExperienceLock, onError);
        };

        self.releaseExperienceLock = function() {
            let lockData = {
                'type': 'editing',
                'model_id': self.pages.experience.eid,
                'model_type': 'experience',
            };
            modelLockService.release(lockData);
        };

        let initiateExperienceLock = function(modelLock) {
            self.modelLock = modelLock;
            self.experienceLockTimeEndDisplay = self.DisplayTime(modelLock.lock_expired_at);
            self.initiateExperienceLockCountdown(modelLock.seconds_left);
        };

        self.initiateExperienceLockCountdown = function (seconds) {
            let then = Date.now() + seconds * 1000;
            if (angular.isDefined(self.experienceLockCountdown)) {
                $interval.cancel(self.experienceLockCountdown);
                self.experienceLockCountdown = undefined
            }
            self.experienceLockCountdown = $interval(function () {
                let secondsLeft = Math.round((then - Date.now()) / 1000);
                if (secondsLeft < 0) {
                    self.experienceLockTimeRemainingDisplay = '0:00';
                    redirectToIndex();
                    $interval.cancel(self.experienceLockCountdown);
                } else {
                    let minutes = Math.floor(secondsLeft / 60);
                    let remainderSeconds = secondsLeft % 60;
                    self.experienceLockTimeRemainingDisplay = minutes + ':' + (remainderSeconds < 10 ? '0' : '') + remainderSeconds;
                    if (secondsLeft === 300) {
                        self.showExtendLock();
                    }
                }
            }, 1000);
        };

        self.DisplayTime = function(timestamp) {
            let end = new Date(timestamp);
            let hour = end.getHours();
            let adjustedHour = hour > 12 ? hour - 12 : hour;
            let minutes = end.getMinutes();
            return adjustedHour + ':' + (minutes < 10 ? '0' : '') + minutes;
        };

        self.showExtendLock = function() {
            var confirm = $mdDialog.confirm()
                    .title('Would you like to extend experience lock?')
                    .textContent('User will be redirected to index page without saving when timer runs out.')
                    .ariaLabel('Timer Dialog')
                    .ok('Extend Lock')
                    .cancel('Close');
            $mdDialog.show(confirm).then(function() {
                self.extendExperienceLock();
            }, function() {
                // this is close
            });
        };
        //END: EXPERIENCE EDIT TIMER

    }
]);
